export const ru = {
    'switch-to-old-interface': 'Если ошибка повторяется, вы можете вернуться в старый интерфейс',
    'switch-to-old-interface-link': 'Вернуться в старый интерфейс'
};
